import React, { Component } from 'react';
import '../custom.css';
import PaymentStatusModal from './PaymentStatusModal';
import { getCardToken, makePaymentByToken, makeManualCardSale, makeAchPayment, postTransactionToDatabase, postPaymentToDatabase, updatePaymentLinkStatus, getCardInfo } from '../services/paymentService';
// import { sendPaymentConfirmationEmail } from '../services/emailService'; // Moved to main Lumina sync process

class PaymentPage extends Component {
    static displayName = "CFM Payment Portal";
    static apiUrl = process.env.REACT_APP_API_URL || '';

    constructor(props) {
        super(props);
        this.state = {
            paymentMethod: 'echeck',
            accountType: '',
            bankName: '',
            routingNumber: '',
            accountNumber: '',
            confirmAccountNumber: '',
            nameOnAccount: '',
            cardholderName: '',
            cardNumber: '',
            expirationDate: '',
            cvv: '',
            billingZip: '',
            isProcessing: false,
            errors: {},
            paymentLink: null,
            loading: true,
            error: null,
            showStatusModal: false,
            paymentStatus: null,
            alreadyPaid: false,
            showExpiredLinkModal: false,
            expiredLinkMessage: '',
            isExpiredLink: false,
            editingAmounts: {},
            customAmounts: {},
            binLookupLoading: false,
            binTypeMessage: '',
        };

        this._binLookupTimer = null;
        this.getCardType = this.getCardType.bind(this);
        this.formatCardNumber = this.formatCardNumber.bind(this);
        this.handleExpiryChange = this.handleExpiryChange.bind(this);
    }

    componentDidMount() {
        document.title = "CFM Payment Portal";
        this.fetchPaymentLinkData();
    }

    componentDidUpdate(prevProps, prevState) {
        if ((!prevState.paymentLink && this.state.paymentLink) ||
            (prevState.loading && !this.state.loading && this.state.paymentLink)) {
            this.updateOpenGraphTags();
        }
    }

    getFriendlyIdentifier = () => {
        const pathSegments = window.location.pathname.split('/');

        if (pathSegments.length >= 2) {
            return pathSegments[1];
        }
        return null;
    }

    updateMetaTag = (property, content) => {
        let metaTag = document.querySelector(`meta[property="${property}"]`);

        if (!metaTag) {
            metaTag = document.createElement('meta');
            metaTag.setAttribute('property', property);
            document.head.appendChild(metaTag);
        }
        metaTag.setAttribute('content', content);
    };

    updateOpenGraphTags = () => {
        const { paymentLink } = this.state;

        if (!paymentLink) return;

        document.title = `CFM Payment Link - ${paymentLink.details?.[0]?.orderNumber || 'Invoice Payment'}`;

        // Open Graph meta tags for SMS link previews
        this.updateMetaTag('og:title', `CFM Payment for ${paymentLink.accountName || 'Customer'}`);
        this.updateMetaTag('og:description', `Pay invoice ${paymentLink.details?.[0]?.orderNumber || ''} - Balance: $${this.calculateTotalAmount(paymentLink.details || [])}`);
        this.updateMetaTag('og:url', window.location.href);
        this.updateMetaTag('og:type', 'website');

        this.updateMetaTag('og:image', 'https://luminapayments.remotetr.com/images/cfm_white.png');
    };

    fetchPaymentLinkData = async () => {
        try {
            const friendlyId = this.getFriendlyIdentifier();

            if (!friendlyId) {
                this.setState({
                    loading: false,
                    error: 'Invalid payment link URL. Please check the URL and try again.'
                });
                return;
            }

            const response = await fetch(`${this.constructor.apiUrl}/paymentlinks/${friendlyId}`);

            if (!response.ok) {
                const errorText = await response.text();
                console.log('Error response text:', errorText);

                // Errors
                if (errorText.includes("expired")) {
                    throw new Error("Your payment link has expired. Please contact us to request a new one.");
                } else if (errorText.includes("already been processed") || errorText.includes("already been paid")) {
                    throw new Error("This payment has already been paid. Thank you!");
                } else {
                    throw new Error(`Payment link not found`);
                }
            }

            const responseText = await response.text();

            console.log('Payment Link Data', responseText);

            let data;
            if (responseText && responseText.trim()) {
                try {
                    data = JSON.parse(responseText);
                } catch (parseError) {
                    console.error('JSON parse error:', parseError);
                    throw new Error(`Failed to parse response as JSON: ${parseError.message}`);
                }
            } else {
                throw new Error('Empty response received from server');
            }


            // Note: CardMachine config from API

            this.setState({
                paymentLink: data,
                alreadyPaid: data.isAlreadyPaid || false,
                isExpiredLink: data.isExpired || false,
                loading: false
            });
        } catch (error) {
            console.error('Error fetching payment link data:', error);
            this.setState({
                loading: false,
                error: error.message || 'Failed to load payment information. Please try again later.'
            });
        }
    }

    handlePaymentMethodSelect = (method) => {
        this.setState({ paymentMethod: method, binTypeMessage: '' });
    }

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    validateForm = () => {
        const errors = {};
        const { paymentMethod, accountType, bankName, routingNumber, accountNumber, confirmAccountNumber, nameOnAccount, cardholderName, cardNumber, expirationDate, cvv, billingZip } = this.state;

        if (paymentMethod === 'echeck') {
            if (!accountType) errors.accountType = 'Account type is required';
            if (!bankName) errors.bankName = 'Bank name is required';
            if (!routingNumber) errors.routingNumber = 'Routing number is required';
            if (!accountNumber) errors.accountNumber = 'Account number is required';
            if (accountNumber !== confirmAccountNumber) errors.confirmAccountNumber = 'Account numbers do not match';
            if (!nameOnAccount) errors.nameOnAccount = 'Name on account is required';
        } else if (paymentMethod === 'credit' || paymentMethod === 'debit') {
            if (!cardholderName) errors.cardholderName = 'Cardholder name is required';
            if (!cardNumber) errors.cardNumber = 'Card number is required';
            if (!expirationDate) errors.expirationDate = 'Expiration date is required';
            if (!cvv) errors.cvv = 'CVV is required';
            if (!billingZip) errors.billingZip = 'Billing zip is required';
        }

        return errors;
    }

    handleProcessPayment = async () => {
        const errors = this.validateForm();
        console.log('Submit');
        if (Object.keys(errors).length === 0) {
            this.setState({ isProcessing: true, error: null });

            try {
                const { paymentLink, paymentMethod, accountType, bankName, routingNumber, accountNumber, nameOnAccount,
                    cardholderName, cardNumber, expirationDate, cvv, billingZip } = this.state;

                if (!paymentLink || !paymentLink.details || paymentLink.details.length === 0) {
                    throw new Error('Payment information is missing or invalid');
                }

                const totalAmount = this.calculateTotalAmount(paymentLink.details);
                const surchargeRate = (window.appConfig?.SurchargePercent ?? 0) / 100;
                const surcharge = paymentMethod === 'credit' ? parseFloat((parseFloat(totalAmount) * surchargeRate).toFixed(2)) : 0;
                const chargeAmount = (parseFloat(totalAmount) + surcharge).toFixed(2);
                const amountInCents = Math.round(parseFloat(chargeAmount) * 100);
                console.log('[PaymentPage] paymentMethod:', paymentMethod, 'totalAmount:', totalAmount, 'surcharge:', surcharge, 'chargeAmount:', chargeAmount, 'amountInCents:', amountInCents);
                const invoiceNumbers = paymentLink.details.map(d => d.orderNumber).join(',');

                let paymentResponse = null;
                let token = '';
                let paymentType = '';

                if (paymentMethod === 'credit' || paymentMethod === 'debit') {
                    paymentType = this.getCardTypeForPayment(cardNumber);

                    const cardMachineConfig = {
                        GMID: paymentLink.GMID || paymentLink.gmid,
                        GTID: paymentLink.GTID || paymentLink.gtid,
                        GMPW: paymentLink.GMPW || paymentLink.gmpw
                    };

                    if (!cardMachineConfig.GMID || !cardMachineConfig.GTID || !cardMachineConfig.GMPW) {
                        throw new Error('Payment configuration is missing. Please contact support.');
                    }

                    const rawCardNumber = cardNumber.replace(/\D/g, '');

                    let medium;
                    let commercialCard = 'N';
                    if (window.appConfig?.BINLookup ?? false) {
                        const expDate = expirationDate.replace(/\D/g, '');
                        const cardInfoResponse = await getCardInfo(rawCardNumber, cardMachineConfig, expDate);
                        console.log('[BIN Lookup] GetCardInfo response:', cardInfoResponse);
                        const selectedMedium = paymentMethod === 'debit' ? "Debit" : "Credit";
                        const binMedium = cardInfoResponse?.CardDebitCreditIndicator === 'D' ? "Debit" : "Credit";
                        commercialCard = cardInfoResponse?.CardCategory === 'Commercial' ? 'Y' : 'N';
                        if (binMedium !== selectedMedium) {
                            this.setState({
                                isProcessing: false,
                                showStatusModal: true,
                                paymentStatus: {
                                    success: false,
                                    errorMessage: `Cannot process a ${binMedium} Card as a ${selectedMedium} Card.`
                                }
                            });
                            return;
                        }
                        medium = binMedium;
                    } else {
                        medium = paymentMethod === 'debit' ? "Debit" : "Credit";
                    }

                    medium = "Credit"; // Always send as Credit

                    const tokenRequest = {
                        AccountNum: rawCardNumber,
                        ExpDate: expirationDate.replace(/\D/g, ''),
                        CVVNum: cvv,
                        CustomerZipCode: billingZip,
                        MainAmt: amountInCents,
                        CardholderName: cardholderName,
                        InvoiceNum: invoiceNumbers,
                        CommercialCard: commercialCard
                    };

                    // TODO: TEMP - always send - medium = "Credit"
                    medium = "Credit";
                    paymentResponse = await makeManualCardSale(tokenRequest, cardMachineConfig, medium);

                    if (!paymentResponse.success) {
                        throw new Error(paymentResponse.message || paymentResponse.ErrorText || 'Payment failed');
                    }
                    token = paymentResponse.CardToken || '';

                } else if (paymentMethod === 'echeck') {
                    // E-check/ACH
                    paymentType = 'E-Check';

                    // Get ACH config from paymentLink (NOTE: API returns uppercase property names)
                    const achConfig = {
                        GMID: paymentLink.GMID || paymentLink.gmid,
                        GTID: paymentLink.GTID || paymentLink.gtid,
                        GMPW: paymentLink.GMPW || paymentLink.gmpw
                    };

                    // Validate ACH config
                    if (!achConfig.GMID || !achConfig.GTID || !achConfig.GMPW) {
                        throw new Error('ACH payment configuration is missing. Please contact support.');
                    }

                    const achData = {
                        EleCheckRoutingNumber: routingNumber,
                        EleCheckAccountNumber: accountNumber,
                        AccountType: accountType,
                        MainAmt: Math.round(parseFloat(totalAmount) * 100),
                        CardholderName: nameOnAccount,
                        BankName: bankName,
                        InvoiceNum: invoiceNumbers
                    };

                    paymentResponse = await makeAchPayment(achData, achConfig, invoiceNumbers);
                    token = accountNumber.slice(-4); // Use last 4 digits as token
                }

                // Validate
                if (!paymentResponse) {
                    throw new Error('No payment response received');
                }

                // Transaction
                const transactionModel = {
                    transactionIdentifier: paymentResponse.transactionId,
                    transactionResponse: JSON.stringify(paymentResponse),
                    responseMessage: paymentResponse.message || '',
                    cardToken: paymentResponse.cardToken || token,
                    GTRC: paymentResponse.GTRC || '',
                    status: paymentResponse.success ? 'Success' : 'Failed',
                    userId: 0,
                    transactionDate: new Date().toISOString(),
                    paymentType: paymentMethod === 'echeck' ? 'E-Check' : 'Credit Card'
                };

                // Extract cardMachineConfig for both credit and ACH transactions
                const cardMachineConfig = {
                    GMID: paymentLink.GMID || paymentLink.gmid,
                    GTID: paymentLink.GTID || paymentLink.gtid,
                    GMPW: paymentLink.GMPW || paymentLink.gmpw
                };

                const transactionResult = await postTransactionToDatabase(transactionModel, cardMachineConfig);

                if (!transactionResult.success) {
                    throw new Error('Failed to save transaction to database');
                }

                const savedTransactionId = transactionResult.data.transactionId;

                if (!savedTransactionId) {
                    console.error('Transaction ID is missing or invalid:', transactionResult);
                    throw new Error('Transaction ID is missing from the response');
                }

                // Success?
                const isSuccessful = paymentResponse && paymentResponse.success;

                if (isSuccessful) {
                    const firstPositive = paymentLink.details.find(d => d.balanceDue > 0) || paymentLink.details[0];
                    const positiveDetails = paymentLink.details.filter(d => d.balanceDue > 0);
                    const negativeDetails = paymentLink.details.filter(d => d.balanceDue < 0);

                    const paymentModel = {
                        paymentId: "",
                        description: paymentLink.details.length > 1
                            ? paymentLink.details.map(detail => `#${detail.orderNumber}`).join(', ')
                            : `#${paymentLink.details[0].orderNumber}`,
                        paymentType,
                        paymentMethod: paymentMethod,
                        status: paymentResponse.success ? 'Success' : 'Failed',
                        fullName: paymentMethod === 'credit' ? cardholderName : nameOnAccount,
                        amount: totalAmount,
                        checkNumber: "",
                        identifier: paymentMethod === 'echeck'
                            ? accountNumber.slice(-4)
                            : cardNumber.replace(/\D/g, '').slice(-4),
                        accountNumber: paymentMethod === 'echeck' ? accountNumber : "",
                        routingNumber: paymentMethod === 'echeck' ? routingNumber : "",
                        bankName: paymentMethod === 'echeck' ? bankName : "",
                        accountType: paymentMethod === 'echeck' ? accountType : "",
                        token: token || '',
                        orderId: firstPositive.orderId,
                        orderNumber: firstPositive.orderNumber,
                        invoiceId: firstPositive.invoiceId || 0,
                        billingGroupId: 0,
                        userId: 0,
                        userName: paymentMethod === 'credit' ? cardholderName : nameOnAccount,
                        lastUsed: new Date().toISOString(),
                        // TEMP = remove negatives
                        // invoices: [
                        //     ...positiveDetails.map(detail => ({
                        //         invoiceId: detail.invoiceId || 0,
                        //         orderId: detail.orderId,
                        //         orderNumber: detail.orderNumber || '',
                        //         amountPaid: parseFloat(parseFloat(this.getCurrentPaymentAmount(detail)).toFixed(2)),
                        //         datePaid: new Date().toISOString()
                        //     })),
                        //     ...negativeDetails.map(detail => ({
                        //         invoiceId: detail.invoiceId || 0,
                        //         orderId: detail.orderId,
                        //         orderNumber: detail.orderNumber || '',
                        //         amountPaid: parseFloat(parseFloat(detail.balanceDue).toFixed(2)),
                        //         datePaid: new Date().toISOString()
                        //     }))
                        // ],
                        invoices: paymentLink.details.map(detail => ({
                            invoiceId: detail.invoiceId || 0,
                            orderId: detail.orderId,
                            orderNumber: detail.orderNumber || '',
                            amountPaid: parseFloat(this.getCurrentPaymentAmount(detail)),
                            datePaid: new Date().toISOString()
                        })),
                        transactionId: savedTransactionId,
                        paymentLinkId: paymentLink.paymentLinkId,
                        paymentDate: new Date().toISOString(),
                        ccSurcharge: surcharge > 0 ? surcharge : null
                    };

                    console.log('Saving payment with transactionId:', savedTransactionId);

                    const paymentResult = await postPaymentToDatabase(paymentModel);

                    if (!paymentResult.success) {
                        throw new Error('Failed to save payment to database');
                    }

                    // Update status
                    const statusUpdateResult = await updatePaymentLinkStatus(paymentLink.paymentLinkId, 'Paid');

                    if (!statusUpdateResult.success) {
                        console.warn('Failed to update payment link status:', statusUpdateResult.message);
                        // Continue ?
                    }

                    const paymentDetails = {
                        date: new Date().toISOString(),
                        invoices: paymentLink.details.map(detail => detail.orderNumber),
                        invoiceDetails: paymentLink.details.map(detail => ({
                            orderNumber: detail.orderNumber,
                            amountPaid: this.getCurrentPaymentAmount(detail)
                        })),
                        paymentMethod: paymentMethod === 'echeck'
                            ? `E-Check (x${accountNumber.slice(-4)})`
                            : `${paymentMethod === 'debit' ? 'Debit' : 'Credit'} Card (x${cardNumber.replace(/\D/g, '').slice(-4)})`,
                        paymentType: paymentType,
                        totalAmount: chargeAmount,
                        payorName: paymentLink.payorName || '',
                        userFullName: paymentLink.userFullName || '',
                        storeName: paymentLink.storeName || '',
                        storeAddress: paymentLink.storeAddress || '',
                        storePhone: paymentLink.storePhone || '',
                        isStatement: paymentLink.isStatement,
                        statementDate: paymentLink.statementDate,
                        accountName: paymentLink.accountName,
                        cfmUserName: paymentLink.userFullName
                    };

                    if (paymentLink.email) {
                        try {
                            console.log('Email confirmation will be sent by main Lumina during payment sync');
                            // const emailResult = await sendPaymentConfirmationEmail(paymentDetails, paymentLink.email, paymentLink.createdBy); // Moved to main Lumina sync
                            paymentDetails.email = paymentLink.email;
                            paymentDetails.emailSent = true; // Will be sent by main Lumina sync
                        } catch (emailError) {
                            console.error('Error sending confirmation email:', emailError);
                        }
                    } else {
                        console.log('No email provided in payment link, skipping confirmation email');
                    }

                    localStorage.setItem('paymentDetails', JSON.stringify(paymentDetails));
                    window.location.href = '/ThankYou';
                } else {
                    // Payment gateway returned a non-success response
                    const errorText = paymentResponse.ErrorText || paymentResponse.message || '';
                    const hasCvvOrZip = errorText.toLowerCase().includes('cvv') || errorText.toLowerCase().includes('zip');

                    const errorStatus = {
                        success: false,
                        message: {
                            invoices: paymentLink.details.map(detail => ({
                                orderNumber: detail.orderNumber,
                                balanceDue: detail.balanceDue,
                                paymentAmount: this.getCurrentPaymentAmount(detail)
                            }))
                        },
                        errorMessage: hasCvvOrZip
                            ? 'Sorry, we were unable to process your payment.  Please confirm your security code and zip were entered correctly and try again.'
                            : undefined
                    };

                    this.setState({
                        isProcessing: false,
                        paymentStatus: errorStatus,
                        showStatusModal: true,
                        error: null 
                    });
                }
            }
            catch (error) {
                console.error('Payment processing error:', error);

                const errorStatus = {
                    success: false,
                    message: {
                        invoices: this.state.paymentLink?.details?.map(detail => ({
                            orderNumber: detail.orderNumber,
                            balanceDue: detail.balanceDue,
                            paymentAmount: this.getCurrentPaymentAmount(detail)
                        })) || []
                    }
                };

                this.setState({
                    isProcessing: false,
                    paymentStatus: errorStatus, // Set details for the modal
                    showStatusModal: true,    // Show the modal
                    error: null               // Explicitly set general error to null
                });
            }
        } else {
            this.setState({ errors });
        }
    }

    getCardTypeForPayment = (number) => {
        const firstDigit = number.replace(/\D/g, '').charAt(0);
        return firstDigit === '3' ? 'AMEX' :
            firstDigit === '4' ? 'VISA' :
                firstDigit === '5' ? 'MC' :
                    firstDigit === '6' ? 'DISCOVER' : 'UNKNOWN';
    }

    handleCloseStatusModal = () => {
        const { paymentStatus } = this.state;
        console.log('Modal closing, payment status:', paymentStatus);
        this.setState({ showStatusModal: false });

        if (paymentStatus && paymentStatus.success) {
            window.location.href = '/thank-you';
        }
    }

    calculateTotalAmount = (details) => {
        if (!details || details.length === 0) return 0;

        const total = details.reduce((total, detail) => {
            if (detail.balanceDue < 0) return total;
            const amount = this.getCurrentPaymentAmount(detail);
            return total + parseFloat(amount);
        }, 0);
        return Math.max(0, total).toFixed(2);
    }

    getCardType(number) {
        const cleanNumber = number.replace(/\D/g, '');
        if (cleanNumber.match(/^3[47]/)) return 'amex';
        if (cleanNumber.match(/^4/)) return 'visa';
        if (cleanNumber.match(/^5[1-5]/)) return 'mastercard';
        if (cleanNumber.match(/^6/)) return 'discover';
        return 'unknown';
    }

    formatCardNumber(value) {
        const cleanValue = value.replace(/\D/g, '');
        const cardType = this.getCardType(cleanValue);

        if (cardType === 'amex') {
            return cleanValue.replace(/(\d{4})(\d{6})(\d{5})/, '$1 $2 $3').trim();
        }

        return cleanValue.replace(/(\d{4})(\d{4})?(\d{4})?(\d{4})?/, (_, p1, p2, p3, p4) => {
            let output = p1 || '';
            if (p2) output += ' ' + p2;
            if (p3) output += ' ' + p3;
            if (p4) output += ' ' + p4;
            return output;
        }).trim();
    }

    handleExpiryChange(e) {
        const { value } = e.target;
        const cleanValue = value.replace(/\D/g, '');

        let formattedValue = cleanValue;
        if (cleanValue.length >= 2) {
            formattedValue = cleanValue.slice(0, 2) + ' / ' + cleanValue.slice(2, 4);
        }

        this.setState({ expirationDate: formattedValue }, () => {
            // Trigger BIN lookup once expiry is complete and card number already has 6+ digits
            if (cleanValue.length < 4) return;
            const rawCardDigits = this.state.cardNumber.replace(/\D/g, '');
            if (rawCardDigits.length < 6) return;
            this.triggerBinLookup(cleanValue);
        });
    }

    handleCardNumberChange = (e) => {
        const { value } = e.target;
        const formattedValue = this.formatCardNumber(value);
        this.setState({ cardNumber: formattedValue }, () => {
            const rawDigits = formattedValue.replace(/\D/g, '');
            if (rawDigits.length < 6) return;

            // wait for expiration date is fully entered
            const expRaw = this.state.expirationDate.replace(/\D/g, '');
            if (expRaw.length < 4) return;

            this.triggerBinLookup(expRaw);
        });
    }

    //  BIN lookup: resolves terminal config from payment link, calls GetCardInfo.
    // expDateOverride lets card-number/expiry handlers pass the just-typed expiry before setState settles.
    triggerBinLookup = (expDateOverride = null) => {
        if (!(window.appConfig?.BINLookup ?? false)) return;

        const { paymentLink, paymentMethod, cardNumber, expirationDate } = this.state;
        if (paymentMethod === 'echeck') return;

        const rawCardDigits = cardNumber.replace(/\D/g, '');
        if (rawCardDigits.length < 6) return;

        const cardMachineConfig = {
            GMID: paymentLink?.GMID || paymentLink?.gmid,
            GTID: paymentLink?.GTID || paymentLink?.gtid,
            GMPW: paymentLink?.GMPW || paymentLink?.gmpw
        };
        if (!cardMachineConfig.GMID || !cardMachineConfig.GMPW) return;

        const expDate = expDateOverride ?? expirationDate.replace(/\D/g, '');

        clearTimeout(this._binLookupTimer);
        this._binLookupTimer = setTimeout(async () => {
            try {
                this.setState({ binLookupLoading: true });
                const cardInfoResponse = await getCardInfo(rawCardDigits, cardMachineConfig, expDate || null);
                const detected = cardInfoResponse?.CardDebitCreditIndicator === 'D' ? 'debit' : 'credit';
                if (detected !== this.state.paymentMethod) {
                    this.setState({ paymentMethod: detected, binTypeMessage: `The card you entered is a ${detected} card.` });
                } else {
                    this.setState({ binTypeMessage: '' });
                }
            } catch (ex) {
                console.log('BIN ERROR: ', ex)
            } finally {
                this.setState({ binLookupLoading: false });
            }
        }, 300);
    }

    handleCvvChange = (e) => {
        const { value } = e.target;
        const cardType = this.getCardType(this.state.cardNumber);
        const maxLength = cardType === 'amex' ? 4 : 3;
        const cleanValue = value.replace(/\D/g, '').slice(0, maxLength);
        this.setState({ cvv: cleanValue });
    }

    handleZipChange = (e) => {
        const { value } = e.target;
        const cleanValue = value.replace(/\D/g, '').slice(0, 5);
        this.setState({ billingZip: cleanValue }, () => {
            // wait for zip is fully entered
            if (cleanValue.length !== 5) return;
            this.triggerBinLookup();
        });
    }

    // Click handler to start editing a payment amount
    handleEditAmount = (orderNumber) => {
        const { paymentLink, customAmounts } = this.state;
        const detail = paymentLink.details.find(d => d.orderNumber === orderNumber);
        if (!detail || detail.balanceDue < 0) return;

        // Initialize custom amount with current amount if not already set
        if (!customAmounts[orderNumber]) {
            const currentAmount = detail.amountPaid > 0 ? detail.amountPaid : detail.balanceDue;
            this.setState({
                customAmounts: {
                    ...customAmounts,
                    [orderNumber]: currentAmount.toString()
                }
            });
        }

        this.setState({
            editingAmounts: {
                ...this.state.editingAmounts,
                [orderNumber]: true
            }
        });
    }

    // Handle changes to payment amount input
    handleAmountChange = (orderNumber, value) => {
        const numericValue = value.replace(/[^0-9.]/g, '');
        
        this.setState({
            customAmounts: {
                ...this.state.customAmounts,
                [orderNumber]: numericValue
            }
        });
    }

    // Handle blur/tab off to finish editing
    handleAmountBlur = (orderNumber) => {
        const { customAmounts } = this.state;
        
        // Validate the amount
        const amount = parseFloat(customAmounts[orderNumber] || 0);
        if (isNaN(amount) || amount < 0) {
            // Reset to original amount if invalid
            const { paymentLink } = this.state;
            const detail = paymentLink.details.find(d => d.orderNumber === orderNumber);
            const originalAmount = detail.amountPaid > 0 ? detail.amountPaid : detail.balanceDue;
            
            this.setState({
                customAmounts: {
                    ...customAmounts,
                    [orderNumber]: originalAmount.toString()
                }
            });
        }

        this.setState({
            editingAmounts: {
                ...this.state.editingAmounts,
                [orderNumber]: false
            }
        });
    }

    // Handle Enter key to finish editing
    handleAmountKeyPress = (e, orderNumber) => {
        if (e.key === 'Enter') {
            this.handleAmountBlur(orderNumber);
        }
    }

    // Get the current payment amount for a specific order
    getCurrentPaymentAmount = (detail) => {
        const { customAmounts } = this.state;
        const customAmount = customAmounts[detail.orderNumber];
        
        if (customAmount !== undefined) {
            return parseFloat(customAmount) || 0;
        }
        
        return detail.amountPaid > 0 ? detail.amountPaid : detail.balanceDue;
    }

    getPdfUrl = (detail, paymentLink) => {
        if (paymentLink.isStatement) {
            const statementPdf = paymentLink.details.find(d => d.pdfUrl);
            return statementPdf ? statementPdf.pdfUrl : null;
        } else {
            return detail.pdfUrl || null;
        }
    }

    isFormValid = () => {
        const {
            paymentMethod,
            accountType,
            bankName,
            routingNumber,
            accountNumber,
            confirmAccountNumber,
            nameOnAccount,
            cardholderName,
            cardNumber,
            expirationDate,
            cvv,
            billingZip
        } = this.state;

        if (paymentMethod === 'echeck') {
            return (
                accountType &&
                bankName &&
                routingNumber && routingNumber.replace(/\D/g, '').length === 9 &&
                accountNumber && accountNumber.replace(/\D/g, '').length >= 8 && accountNumber.replace(/\D/g, '').length <= 12 &&
                confirmAccountNumber &&
                nameOnAccount &&
                accountNumber === confirmAccountNumber
            );
        } else if (paymentMethod === 'credit' || paymentMethod === 'debit') {
            return (
                cardholderName &&
                cardNumber &&
                expirationDate &&
                cvv &&
                billingZip && billingZip.length === 5
            );
        }
        return false; // Should not happen..
    }

    render() {
        const {
            paymentMethod,
            accountType,
            bankName,
            routingNumber,
            accountNumber,
            confirmAccountNumber,
            nameOnAccount,
            cardholderName,
            cardNumber,
            expirationDate,
            cvv,
            billingZip,
            isProcessing,
            errors,
            paymentLink,
            loading,
            error,
            showStatusModal,
            paymentStatus,
            alreadyPaid,
            isExpiredLink,
            binLookupLoading,
            binTypeMessage
        } = this.state;

        // Loading
        if (loading) {
            return (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: '#f9fafb'
                }}>
                    <div style={{ display: 'flex', alignItems: 'center', whiteSpace: 'nowrap' }}>
                        <svg className="animate-spin" style={{ marginRight: '8px', height: '16px', width: '16px', color: '#3b82f6' }} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                        </svg>
                        <span style={{ color: '#4b5563', fontSize: '16px' }}>Loading Payment</span>
                    </div>
                </div>
            );
        }

        // Error
        if (error) {
            return (
                <div style={{
                    display: 'flex',
                    position: 'fixed',
                    width: '100vw',
                    height: '100vh',
                    top: 0,
                    left: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#fff',
                    zIndex: 9999
                }}>
                    <div style={{
                        textAlign: 'center',
                        maxWidth: '400px',
                        padding: '20px'
                    }}>
                        <img src="/images/cfm_logo_white.png" alt="Contract Furnishings Mart" className="mb-4" style={{ display: 'inline-block' }} />
                        <h1 className="font-bold" style={{ color: '#4b5563', fontSize: '24px', marginBottom: '12px' }}>{error}</h1>
                        <p style={{ color: '#6b7280', fontSize: '14px' }}>
                            If you believe this is an error, please contact customer support.
                        </p>
                    </div>
                </div>
            );
        }

        // No payment link data, show friendly error
        if (!paymentLink) {
            return (
                <div style={{
                    display: 'flex',
                    position: 'fixed',
                    width: '100vw',
                    height: '100vh',
                    top: 0,
                    left: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f9fafb',
                    zIndex: 9999
                }}>
                    <div style={{
                        textAlign: 'center',
                        maxWidth: '400px',
                        padding: '20px'
                    }}>
                        <h2 style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '8px' }}>Payment Link Not Found</h2>
                        <p style={{ color: '#4b5563', fontSize: '16px', marginBottom: '12px' }}>
                            We couldn't find the payment information you're looking for.
                            Please check the URL and try again.
                        </p>
                    </div>
                </div>
            );
        }

        // Expired Link
        if (isExpiredLink) {
            return (
                <div style={{
                    display: 'flex',
                    position: 'fixed',
                    width: '100vw',
                    height: '100vh',
                    top: 0,
                    left: 0,
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#fff',
                    zIndex: 9999
                }}>
                    <div style={{
                        textAlign: 'center',
                        maxWidth: '400px',
                        padding: '20px'
                    }}>
                        <img src="/images/cfm_logo_white.png" alt="Contract Furnishings Mart" className="mb-4" style={{ display: 'inline-block', marginBottom: '20px' }} />
                        <h1 className="font-bold" style={{ color: '#4b5563', fontSize: '18px', marginBottom: '8px' }}>
                            Your payment link has expired.
                        </h1>
                        <p style={{ color: '#4b5563', fontSize: '18px', fontWeight: 'bold', marginBottom: '40px' }}>
                            Please contact us to request a new one.
                        </p>
                        <p style={{ fontSize: '14px', color: '#333' }}>
                            <a href={`mailto:${paymentLink.createdBy}?subject=Expired Payment Link`}>
                                {paymentLink.createdBy}
                            </a>
                        </p>
                    </div>
                </div>
            );
        }

        // Total payment amount
        const surchargePercent = window.appConfig?.SurchargePercent ?? 0;
        const surchargeRate = surchargePercent / 100;
        const totalAmount = this.calculateTotalAmount(paymentLink.details);
        const surcharge = paymentMethod === 'credit' ? parseFloat((parseFloat(totalAmount) * surchargeRate).toFixed(2)) : 0;
        const chargeAmount = (parseFloat(totalAmount) + surcharge).toFixed(2);

        return (
            <div className="bg-gray-50 min-h-screen py-4 md:py-8 px-0 md:px-4 border-blue-600 border">
                <div className="max-w-4xl mx-auto bg-white p-6 rounded shadow-sm">
                    {/* Header */}
                    <div className="flex flex-col md:flex-row justify-between items-center md:items-start mb-6">
                        <div className="flex items-center mb-3 md:mb-0">
                            <img
                                src="/images/cfm_logo_white.png"
                                alt="Contract Furnishings Mart"
                                className=""
                            />
                        </div>
                        <div className="text-center md:text-right">
                            <div className="text-blue-700 font-bold" style={{ fontSize: '18px', color: '#0047AB' }}>
                                {paymentLink.isStatement
                                    ? "CFM Statement"
                                    : "CFM Payment Link"}
                            </div>
                            {!paymentLink.isStatement && paymentLink.details && (
                                <div className="text-blue-700 mt-1">
                                    {paymentLink.details.length === 1
                                        ? `Invoice: ${paymentLink.details[0].orderNumber}`
                                        : `${paymentLink.details.length} Invoices`}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Account Info */}
                    <div className="mb-4 text-left">
                        <div className="grid grid-cols-[120px_1fr] gap-y-2">
                            <div className="font-medium">Account Name:</div>
                            <div className="font-bold">{paymentLink.accountName}</div>
                            <div className="font-medium">Date:</div>
                            <div className="font-bold">
                                {paymentLink.statementDate ?
                                    new Date(paymentLink.statementDate).toLocaleDateString('en-US', {
                                        month: '2-digit',
                                        day: '2-digit',
                                        year: 'numeric'
                                    }) : 'N/A'}
                            </div>
                        </div>
                    </div>

                    {/* Invoice Table */}
                    <div className="overflow-x-auto mb-6">
                        <table className="w-full border-collapse border border-gray-300">
                            <thead>
                                <tr className="bg-gray-100">
                                    <th className="border border-gray-300 p-2 text-left">Invoice #</th>
                                    <th className="border border-gray-300 p-2 text-left">Job Name</th>
                                    {!alreadyPaid && <th className="border border-gray-300 p-2 text-left">Type</th>}
                                    <th className="border border-gray-300 p-2 text-right">{alreadyPaid ? "Balance Remaining" : "Balance Due"}</th>
                                    {!alreadyPaid && <th className="border border-gray-300 p-2 text-right">Payment Amount</th>}
                                </tr>
                            </thead>
                            <tbody>
                                {paymentLink.details.filter(detail => detail.balanceDue >= 0).map((detail, index) => (
                                    <tr key={index} className="">
                                        <td className="border border-gray-300 p-2">
                                            {detail.pdfUrl ? (
                                                <a
                                                    href={detail.pdfUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="flex items-center text-blue-600 hover:text-blue-800 hover:underline"
                                                    title="View Invoice PDF"
                                                >
                                                    <span>{detail.orderNumber}</span>
                                                </a>
                                            ) : (
                                                <span>{detail.orderNumber}</span>
                                            )}
                                        </td>
                                        <td className="border border-gray-300 p-2">{detail.jobName}</td>
                                        {!alreadyPaid && (
                                            <td className="border border-gray-300 p-2">
                                                {paymentMethod === 'credit' ? 'Credit' : paymentMethod === 'debit' ? 'Debit' : 'E-Check'}
                                            </td>
                                        )}
                                        <td className="border border-gray-300 p-2 text-right">
                                            {detail.balanceDue < 0
                                                ? `-$${Math.abs(parseFloat(alreadyPaid ? detail.balanceDue - detail.amountPaid : detail.balanceDue)).toFixed(2)}`
                                                : `$${parseFloat(alreadyPaid ? detail.balanceDue - detail.amountPaid : detail.balanceDue).toFixed(2)}`}
                                        </td>
                                        {!alreadyPaid && (
                                            <td className="border border-gray-300 p-2 text-right">
                                                {detail.balanceDue < 0 ? (
                                                    <span className="text-green-700 italic text-sm">Credit Applied</span>
                                                ) : this.state.editingAmounts[detail.orderNumber] ? (
                                                    <div className="flex items-center">
                                                        <span className="text-gray-600 mr-1">$</span>
                                                        <input
                                                            type="text"
                                                            value={this.state.customAmounts[detail.orderNumber] || ''}
                                                            onChange={(e) => this.handleAmountChange(detail.orderNumber, e.target.value)}
                                                            onBlur={() => this.handleAmountBlur(detail.orderNumber)}
                                                            onKeyPress={(e) => this.handleAmountKeyPress(e, detail.orderNumber)}
                                                            className="flex-1 text-right p-1 border border-blue-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                            autoFocus
                                                        />
                                                    </div>
                                                ) : (
                                                    <span
                                                        onClick={() => this.handleEditAmount(detail.orderNumber)}
                                                        className="cursor-pointer hover:bg-blue-50 hover:text-blue-600 p-1 rounded transition-colors"
                                                        title="Click to edit payment amount"
                                                    >
                                                        ${this.getCurrentPaymentAmount(detail).toFixed(2)}
                                                    </span>
                                                )}
                                            </td>
                                        )}
                                    </tr>
                                ))}
                                {!alreadyPaid && (
                                    <>
                                        {surchargePercent > 0 && paymentMethod === 'credit' && (
                                            <tr className="bg-gray-200">
                                                <td className="border border-gray-300 p-2" colSpan="4">Credit Card Surcharge ({surchargePercent}%)</td>
                                                <td className="border border-gray-300 p-2 text-right">${surcharge.toFixed(2)}</td>
                                            </tr>
                                        )}
                                        <tr className="bg-gray-200 font-bold">
                                            <td className="border border-gray-300 p-2" colSpan="4">Total Payment Amount</td>
                                            <td className="border border-gray-300 p-2 text-right">${paymentMethod === 'credit' ? chargeAmount : totalAmount}</td>
                                        </tr>
                                    </>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Conditional Payment Section */}
                    {!alreadyPaid ? (
                        <>
                            {/* Payment Methods - Better grid layout for mobile */}
                            <div className="grid md:grid-cols-[auto_1fr] gap-6">
                                <div className="flex flex-col items-stretch space-y-[26px] mt-2">
                                    <button
                                        className={`h-10 px-4 rounded flex items-center justify-center transition-colors whitespace-nowrap ${paymentMethod === 'echeck'
                                            ? 'btn-blue font-bold'
                                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                            }`}
                                        onClick={() => this.handlePaymentMethodSelect('echeck')}
                                    >
                                        PAY VIA E-CHECK
                                    </button>
                                    <button
                                        className={`h-10 px-4 rounded flex items-center justify-center transition-colors whitespace-nowrap ${paymentMethod === 'credit'
                                            ? 'btn-blue font-bold'
                                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                            }`}
                                        onClick={() => this.handlePaymentMethodSelect('credit')}
                                    >
                                        PAY VIA CREDIT CARD
                                    </button>
                                    <button
                                        className={`h-10 px-4 rounded flex items-center justify-center transition-colors whitespace-nowrap ${paymentMethod === 'debit'
                                            ? 'btn-blue font-bold'
                                            : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
                                            }`}
                                        onClick={() => this.handlePaymentMethodSelect('debit')
                                        }
                                    >
                                        PAY VIA DEBIT CARD
                                    </button>
                                </div>

                                {/* Form Fields */}
                                <div>
                                    {/* E-Check Form */}
                                    {paymentMethod === 'echeck' && (
                                        <div className="space-y-2 -mr-2.5 -ml-2.5">
                                            {/* Account Type */}
                                            <div className="form-control b-0">
                                                <select
                                                    name="accountType"
                                                    value={accountType}
                                                    className="select select-bordered w-full h-10 px-3 py-2 rounded"
                                                    onChange={this.handleInputChange}
                                                >
                                                    <option value="">Account Type</option>
                                                    <option value="checking">Checking</option>
                                                    <option value="savings">Savings</option>
                                                </select>
                                            </div>

                                            {/* Bank Name */}
                                            <div className="form-control">
                                                <input
                                                    type="text"
                                                    name="bankName"
                                                    placeholder="Bank Name"
                                                    className="input input-bordered w-full h-10 px-3 py-2 rounded"
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>

                                            {/* Routing Number */}
                                            <div className="form-control">
                                                <input
                                                    type="text"
                                                    name="routingNumber"
                                                    placeholder="Routing Number"
                                                    className="input input-bordered w-full h-10 px-3 py-2 rounded"
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>

                                            {/* Account Number */}
                                            <div className="form-control">
                                                <input
                                                    type="text"
                                                    name="accountNumber"
                                                    placeholder="Account Number"
                                                    className="input input-bordered w-full h-10 px-3 py-2 rounded"
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>

                                            {/* Confirm Account Number */}
                                            <div className="form-control">
                                                <input
                                                    type="text"
                                                    name="confirmAccountNumber"
                                                    placeholder="Confirm Account Number"
                                                    className="input input-bordered w-full h-10 px-3 py-2 rounded"
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>

                                            {/* Name on Account */}
                                            <div className="form-control">
                                                <input
                                                    type="text"
                                                    name="nameOnAccount"
                                                    placeholder="Name on Bank Account"
                                                    className="input input-bordered w-full h-10 px-3 py-2 rounded"
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>
                                        </div>
                                    )}

                                    {/* Credit / Debit Card Form */}
                                    {(paymentMethod === 'credit' || paymentMethod === 'debit') && (
                                        <div className="space-y-2 -mr-2.5 -ml-2.5">
                                            {/* Cardholder Name */}
                                            <div className="form-control">
                                                <input
                                                    type="text"
                                                    name="cardholderName"
                                                    placeholder="Cardholder Name"
                                                    className="input input-bordered w-full h-10 px-3 py-2 rounded payment-input"
                                                    value={cardholderName}
                                                    onChange={this.handleInputChange}
                                                />
                                            </div>

                                            {/* Card Number */}
                                            <div className="form-control card-input-container relative">
                                                <input
                                                    type="text"
                                                    name="cardNumber"
                                                    placeholder="Card Number"
                                                    className="input input-bordered w-full h-10 px-3 py-2 rounded card-number-input payment-input"
                                                    value={cardNumber}
                                                    onChange={this.handleCardNumberChange}
                                                    maxLength={this.getCardType(cardNumber) === 'amex' ? 17 : 19}
                                                />
                                                <div className="card-type-icon flex gap-2 absolute right-3 top-1/2 transform -translate-y-1/2">
                                                    {binLookupLoading ? (
                                                        <svg className="animate-spin h-4 w-4 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
                                                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"/>
                                                        </svg>
                                                    ) : (
                                                        <>
                                                            <div className={`card-icon visa-icon ${this.getCardType(cardNumber) === 'visa' ? 'opacity-100' : 'opacity-40'}`}></div>
                                                            <div className={`card-icon mastercard-icon ${this.getCardType(cardNumber) === 'mastercard' ? 'opacity-100' : 'opacity-40'}`}></div>
                                                            <div className={`card-icon amex-icon ${this.getCardType(cardNumber) === 'amex' ? 'opacity-100' : 'opacity-40'}`}></div>
                                                            <div className={`card-icon discover-icon ${this.getCardType(cardNumber) === 'discover' ? 'opacity-100' : 'opacity-40'}`}></div>
                                                        </>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Expiration, CVV and Zip in one row */}
                                            <div className="flex w-full space-x-2">
                                                {/* Expiration Date */}
                                                <div className="form-control flex-1">
                                                    <input
                                                        type="text"
                                                        name="expirationDate"
                                                        placeholder="MM / YY"
                                                        className="input input-bordered w-full h-10 px-3 py-2 rounded payment-input"
                                                        value={expirationDate}
                                                        onChange={this.handleExpiryChange}
                                                        maxLength={7}
                                                    />
                                                </div>

                                                {/* CVV */}
                                                <div className="form-control flex-1">
                                                    <input
                                                        type="text"
                                                        name="cvv"
                                                        placeholder="CVV"
                                                        className="input input-bordered w-full h-10 px-3 py-2 rounded payment-input"
                                                        value={cvv}
                                                        onChange={this.handleCvvChange}
                                                        maxLength={this.getCardType(cardNumber) === 'amex' ? 4 : 3}
                                                    />
                                                </div>

                                                {/* Billing Zip */}
                                                <div className="form-control flex-1">
                                                    <input
                                                        type="text"
                                                        name="billingZip"
                                                        placeholder="Billing Zip"
                                                        className="input input-bordered w-full h-10 px-3 py-2 rounded payment-input"
                                                        value={billingZip}
                                                        onChange={this.handleZipChange}
                                                        maxLength={5}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Process Button */}
                            <div className="mt-4">
                                {binTypeMessage && <p className="font-lg text-red-600 font-bold mb-1">{binTypeMessage}</p>}
                                {surchargePercent > 0 && <p className="text-gray-600 mb-1">* A {surchargePercent}% surcharge will be added to all credit card transactions</p>}
                            </div>
                            <div className="mt-1">
                                <button
                                    className="btn-sm w-full py-2 px-4  bg-green-600 hover:bg-green-600 text-white font-bold rounded flex items-center justify-center transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed"
                                    onClick={this.handleProcessPayment}
                                    disabled={isProcessing || !this.isFormValid()}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 mr-2"
                                        viewBox="0 0 20 20"
                                        fill="currentColor"
                                        aria-hidden="true"
                                    >
                                        <path
                                            fillRule="evenodd"
                                            d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                                            clipRule="evenodd"
                                        />
                                    </svg>
                                    {isProcessing ? 'PROCESSING...' : `PROCESS PAYMENT $${paymentMethod === 'credit' ? chargeAmount : totalAmount}`}
                                </button>
                            </div>
                        </>
                    ) : (
                        /* Already Paid */
                        <div className="text-center" style={{ marginTop: '20px' }}>
                            <p style={{ fontWeight: 'bold', fontSize: '18px', marginBottom: '5px', paddingTop: '20px', color: '#333' }}>Your payment has been received.</p>
                            <p style={{ fontSize: '18px', fontWeight: 'bold', color: '#333' }}>Thank you!</p>
                            <p style={{ fontSize: '14px', color: '#333', paddingTop: '40px' }}>
                                <a href={`mailto:${paymentLink.createdBy}?subject=CFM Payment Link Customer Inquiry`}>{paymentLink.createdBy}</a>
                            </p>
                        </div>
                    )}
                </div>

                <PaymentStatusModal
                    show={showStatusModal}
                    onClose={this.handleCloseStatusModal}
                    status={paymentStatus}
                />
            </div>
        );
    }
}

export default PaymentPage;